import * as React from 'react';
import { UIHeading3 } from '@cian/ui-kit/typography';
import { IconToggleStarOn16 } from '@cian/ui-kit-design-tokens/icons';

interface IRateMobileProps {
  rate: string;
}

export const RateMobile: React.FunctionComponent<IRateMobileProps> = ({ rate }) => {
  return (
    <div>
      <UIHeading3 as="span" textAlign="center">
        <IconToggleStarOn16 color={'warning_100'} />
        <span> </span>
        {rate}
      </UIHeading3>
    </div>
  );
};
